module.exports = __webpack_public_path__ + "b73933face103d9df70d3cf74fbe069d.svg";